import { useQueries } from '@tanstack/react-query';
import { BigNumber } from 'bignumber.js';

import { SendableCoinInfo } from './get-send-disabled-reason';
import { getOwnedCoinObjects } from './owned-coin-objects';

const SENDABLE_COIN_COUNT_QUERY_KEY = 'sui-sendable-coin-count';

export function useSendableCoinCounts(
  coinTypes: string[],
  owner: string | undefined,
  enabled: boolean,
): Record<string, SendableCoinInfo> {
  const results = useQueries({
    queries: coinTypes.map((coinType) => ({
      queryKey: [SENDABLE_COIN_COUNT_QUERY_KEY, owner, coinType],
      queryFn: () => getOwnedCoinObjects(owner ?? '', coinType),
      enabled: enabled && !!owner,
    })),
  });

  return Object.fromEntries(
    coinTypes.map((coinType, index) => [
      coinType,
      {
        isLoading: results[index]?.isPending ?? true,
        hasCoinObjects: (results[index]?.data?.coins.length ?? 0) > 0,
        checkFailed: results[index]?.isError ?? false,
        hasAddressBalance: new BigNumber(results[index]?.data?.addressBalance ?? 0).isGreaterThan(
          0,
        ),
      },
    ]),
  );
}
